module.exports = __webpack_public_path__ + "img/37c12782ac64490a0d4aa007945a608e.png";